import { forwardRef } from 'react';

import * as S from './Button.style';
import { IButtonProps } from './Button.type';

const Button = forwardRef(
	(props: IButtonProps, ref: React.ComponentPropsWithRef<React.ElementType>['ref']) => (
		<S.Container {...props} ref={ref}>
			{props.children}
		</S.Container>
	),
);

Button.displayName = 'Button';

export { Button };
